export default state => state.vod.hodor.authenticate.token;
